import { render, staticRenderFns } from "./data3.vue?vue&type=template&id=6f0d9a8e&scoped=true"
import script from "./data3.vue?vue&type=script&lang=js"
export * from "./data3.vue?vue&type=script&lang=js"
import style0 from "./data3.vue?vue&type=style&index=0&id=6f0d9a8e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0d9a8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0d9a8e')) {
      api.createRecord('6f0d9a8e', component.options)
    } else {
      api.reload('6f0d9a8e', component.options)
    }
    module.hot.accept("./data3.vue?vue&type=template&id=6f0d9a8e&scoped=true", function () {
      api.rerender('6f0d9a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/hotelInit/data3.vue"
export default component.exports